// extracted by mini-css-extract-plugin
module.exports = {"SpecialOffersWrapper":"purify_index__SpecialOffersWrapper--17_EP","specialOffersWrapper":"purify_index__SpecialOffersWrapper--17_EP"};